/**
 * Created by Alican Köker on 2019-01-09.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";
import {EdisonReelAreaView} from "../../reel/EdisonReelAreaView";
import {EdisonStateReelSymbol} from "../../reel/reelSymbol/EdisonStateReelSymbol";
import {EdisonParsedGameData} from "../../server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "../../server/data/EdisonParsedInitData";
import {EdisonIndividualWPView} from "../../winpresentation/individual/EdisonIndividualWPView";
import {EdisonFreespinOverlay} from "./EdisonFreespinOverlay";

export class EdisonFreespinController extends BaseController {

    //DATA
    private _gameData:EdisonParsedGameData;
    private _indicatorValues:number[];

    //indicator values

    private _multiplierValue:number;
    private _featureSymbols:string[] = EdisonGameConfig.instance.FEATURE_SYMBOLS;
    private _meterFSReset:boolean[] = [false, false, false, false, false];
    private _currentMeterValues:number[] = [0, 0, 0, 0, 0, 0];
    private _fsMeterAfterEachReel:number[][] = [];
    private _initiated:boolean = false;
    private _orientation:Orientation;

    constructor() {
        super();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, EdisonReelAreaView.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        if(data.isRestoreState && (data.mode === EdisonGameMode.FREESPIN || data.nextMode === EdisonGameMode.FREESPIN)) {
            this.restoreFreespin(data);
            EventHandler.dispatchEvent(new GameEvent(EdisonIndividualWPView.SET_MODE, EdisonGameMode.FREESPIN));
        }
        EventHandler.dispatchEvent(new GameEvent(EdisonIndividualWPView.SET_MODE, data.mode));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this._gameData = data;

        this.indicatorValues = data.symbolsCollectedAfter;
        this._meterFSReset = data.meterFSReset;
        this._fsMeterAfterEachReel = data.fsMeterAfterEachReel;
        if(this._fsMeterAfterEachReel)
            this.limitMaxValueOnTheMeters(this._fsMeterAfterEachReel);

        EdisonGameModuleConfig.freespinOverlay.restoreMode = false;
        EventHandler.dispatchEvent(new GameEvent(EdisonFreespinOverlay.SET_MODE, data.mode));
    }

    private set multiplierValue(value:number) {
        this._multiplierValue = value;
    }

    private set indicatorValues(val:number[]) {
        this._indicatorValues = val;
    }


    public updateFreespinElements(reelId:number):void {

        const indicatorUpdateDelay:number = .5;
        const swooshAnimLength:number = 1;
        let tl:TimelineLite = new TimelineLite();
        let vals:number[] = reelId !== undefined ? this._fsMeterAfterEachReel[reelId] : this._indicatorValues;
        let valuesToBeUpdated:number[] = [0, 0, 0, 0, 0, 0];

        vals.forEach((val, index) => {
            if(val > this._currentMeterValues[index])
                valuesToBeUpdated[index] = val;
        });

        tl.add(() => this.highlightSymbol(reelId));
        tl.add(() => EdisonGameModuleConfig.freespinOverlay.updateMeterValues(valuesToBeUpdated), indicatorUpdateDelay);

        if(reelId === 4) {
            let featSymbolNamesOnReel:string[] = this.checkCapHits();
            for(let i:number = 0; i < featSymbolNamesOnReel.length; i++) {
                SlotGame.sound.fadeAmbience(0, featSymbolNamesOnReel.length * 7000);
                let symName:string = featSymbolNamesOnReel[i];
                let direction:string = this.determineSwooshDirection(this._featureSymbols.indexOf(symName));
                let symbols:EdisonStateReelSymbol[][] = this.getSymbolsToTurnGoldByDirection(symName, direction);

                tl.add(() => {
                    this.playSwooshSequence(symName, symbols);
                }, i * swooshAnimLength + 1);

            }
        }
    }

    private limitMaxValueOnTheMeters(arrToLimit:number[][]):void {
        for(let i:number = 0; i < arrToLimit.length; i++) {
            for(let j:number = 0; j < arrToLimit[i].length; j++) {
                if(arrToLimit[i][j] > EdisonGameModuleConfig.freespinOverlay.meterCap(j))
                    arrToLimit[i][j] = EdisonGameModuleConfig.freespinOverlay.meterCap(j);
            }
        }
    }

    //returns feature symbol that hit the cap if there is any
    public checkCapHits():string[] {
        let hitArr:string[] = [];
        for(let i:number = 0; i < this._indicatorValues.length; i++) {
            if(this._meterFSReset[i]) {
                hitArr.push(this._featureSymbols[i]);
            }
        }
        return hitArr;
    }

    private highlightSymbol(reelId:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < 3; i++) {
            let sym:EdisonStateReelSymbol = <EdisonStateReelSymbol>Reels.getSymbol(reelId, i);
            if(sym) {
                let featuredSymbolIndex:number = this._featureSymbols.indexOf(sym.symName);
                tl.add(() => EdisonGameModuleConfig.freespinOverlay.playBlinkAnimation(reelId, i, featuredSymbolIndex));
            }
        }
        return tl;
    }

    private playSwooshSequence(symName:string, symbols:EdisonStateReelSymbol[][]):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            EdisonGameModuleConfig.freespinOverlay.resetMeterLights(this._featureSymbols.indexOf(symName));
            this.highlightGoldSwitchSymbols(symName);
        }, 1);
        tl.add(() => {
            EdisonGameModuleConfig.freespinOverlay.playSwooshAnim(this._featureSymbols.indexOf(symName));
            SlotGame.sound.playEffect(EdisonSoundConfig.instance.FS_METER_SWOOSH);
        }, 1);

        tl.add(() => {
            this.changeSymbolsToGold(symbols, symName);
        }, 1.2);

        return tl;
    }

    private highlightGoldSwitchSymbols(symName:string):TimelineLite {
        const goldPositions:boolean[][] = this.determineGoldSwitchPositions(symName);
        let tl:TimelineLite = new TimelineLite();

        goldPositions.forEach((reel, reelIndex) => {
            reel.forEach((switchable, symIndex) => {
                if(switchable)
                    tl.add(() => {
                        EdisonGameModuleConfig.freespinOverlay.blinkGoldSwitch(reelIndex, symIndex, this._featureSymbols.indexOf(symName));
                    });
            });
        });

        return tl;
    }

    private determineGoldSwitchPositions(featuredSymName:string):boolean[][] {
        let positions:boolean[][] = [];

        this._gameData.evaluatedArea.forEach((reel, reelIndex) => {
            let reelArr:boolean[] = [];
            reel.forEach((symName, symIndex) => {
                reelArr.push(symName === "W" && this._gameData.reels[reelIndex][symIndex + 1] === featuredSymName)
            });
            positions.push(reelArr);
        });

        return positions;
    }

    private determineSwooshDirection(meterSymIndex:number):string {
        let direction:string = "right";

        if(this._orientation === Orientation.PORTRAIT) {
            direction = "up";
        } else {
            if(meterSymIndex === 1 || meterSymIndex === 2 || meterSymIndex === 3)
                direction = "left"
        }

        return direction;
    }

    private changeSymbolsToGold(symbols:EdisonStateReelSymbol[][], symName:string):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        let turned:boolean = false;
        symbols.forEach((lineArr, lineInd) => {
            lineArr.forEach((sym, symInd) => {
                if(sym && sym.symName === symName) {
                    tl.add(() => {
                        if(!turned) {
                            SlotGame.sound.playEffect(EdisonSoundConfig.instance.M_TURN_GOLD);
                            turned = true;
                        }
                        EdisonGameModuleConfig.symbolController.changeSymbolState(sym, EdisonGameConfig.instance.SYMBOL_STATES.gold);
                    }, lineInd * .5 + symInd * .05);
                }
            });
        });

        return tl;
    }

    private getSymbolsToTurnGoldByDirection(symName:string, direction:string):EdisonStateReelSymbol[][] {
        let symsToReturn:EdisonStateReelSymbol[][] = [];
        let symArr:EdisonStateReelSymbol[] = [];

        if(direction === "right") {
            for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
                let syms:EdisonStateReelSymbol[] = <EdisonStateReelSymbol[]>Reels.allSymbols(i);
                for(let j:number = 2; j < 5; j++) {
                    let sym:EdisonStateReelSymbol = syms[j];
                    if(sym && sym.symName === symName) {
                        symArr.push(sym);
                    }
                }
            }
            symsToReturn.push(symArr);
        } else if(direction === "left") {
            for(let i:number = EdisonGameConfig.instance.REELS_NUM - 1; i > -1; i--) {
                let syms:EdisonStateReelSymbol[] = <EdisonStateReelSymbol[]>Reels.allSymbols(i);
                for(let j:number = 2; j < 5; j++) {
                    let sym:EdisonStateReelSymbol = syms[j];
                    if(sym && sym.symName === symName) {
                        symArr.push(sym);
                    }
                }
            }
            symsToReturn.push(symArr);
        } else {/** up */
            for(let j:number = 2; j > -1; j--) {
                for(let i:number = EdisonGameConfig.instance.REELS_NUM - 1; i > -1; i--) {
                    let sym:EdisonStateReelSymbol | null = <EdisonStateReelSymbol>Reels.getSymbol(i, j);
                    if(sym && sym.symName === symName) {
                        symArr.push(sym);
                    }
                }
                symsToReturn.push(symArr);
            }
        }

        return symsToReturn;
    }

    public deactivateFreespinOverlay():void {
        EdisonGameModuleConfig.freespinOverlay.deactivateView();
        this._initiated = false;
    }

    public restoreFreespin(data:EdisonParsedInitData):void {
        this._initiated = true;
        this.multiplierValue = data.currentMultiplier;
        this.indicatorValues = data.symbolsCollected;
        EdisonGameModuleConfig.freespinOverlay.restoreMode = true;
        EdisonGameModuleConfig.freespinOverlay.activateView();

        //wait for the meters to show --animation takes a short while.
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            EdisonGameModuleConfig.freespinOverlay.updateMeterValues(this._indicatorValues);
        }, 2);

        SlotGame.sound.playAmbience(EdisonSoundConfig.instance.FREESPIN_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);
    }

    private onOrientationChange(data:IResizeData):void {
        this._orientation = data.orientation;
    }

}